"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MNDE_MINT = exports.MNDE_VSR_REGISTRAR_ADDRESS = exports.MNDE_REALM_ADDRESS = exports.MNDE_VSR_PROGRAM_ID = exports.MNDE_GOVERNANCE_PROGRAM_ID = exports.MANGO_VSR_PROGRAM_ID = exports.SPL_GOVERNANCE_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
// SPL Governance Program ID
// https://github.com/solana-labs/solana-program-library/
exports.SPL_GOVERNANCE_PROGRAM_ID = new web3_js_1.PublicKey('GovER5Lthms3bLBqWub97yVrMmEogzX7xNjdXpPPCVZw');
// Voter Stake Registry Program ID
// https://github.com/blockworks-foundation/voter-stake-registry
exports.MANGO_VSR_PROGRAM_ID = new web3_js_1.PublicKey('4Q6WW2ouZ6V3iaNm56MTd5n2tnTm4C5fiH8miFHnAFHo');
exports.MNDE_GOVERNANCE_PROGRAM_ID = new web3_js_1.PublicKey('GovMaiHfpVPw8BAM1mbdzgmSZYDw2tdP32J2fapoQoYs');
exports.MNDE_VSR_PROGRAM_ID = new web3_js_1.PublicKey('VoteMBhDCqGLRgYpp9o7DGyq81KNmwjXQRAHStjtJsS');
exports.MNDE_REALM_ADDRESS = new web3_js_1.PublicKey('899YG3yk4F66ZgbNWLHriZHTXSKk9e1kvsKEquW7L6Mo');
exports.MNDE_VSR_REGISTRAR_ADDRESS = new web3_js_1.PublicKey('5zgEgPbWKsAAnLPjSM56ZsbLPfVM6nUzh3u45tCnm97D');
exports.MNDE_MINT = new web3_js_1.PublicKey('MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey');
//# sourceMappingURL=pubkeys.js.map